import Vue from 'vue';

export const isUserNotLoggedIn = async (to, form, next) => {
  try {
    const loggedInUser =
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
    if (loggedInUser && loggedInUser.signInUserSession)
      return next({ name: 'home', query: { section: 'data' } });
    return next();
  } catch (error) {
    return next();
  }
};
